import { VerticalNavbar } from '../navbar/VerticalNavbar';

export const App = (props: any) => {
	return <VerticalNavbar {...props} />;
};
